"use client"

import { ColumnDef } from "@tanstack/react-table"
import { formatRelativeTime } from "~/common/format-relative-time"
import { parseISO } from "date-fns"
import { RemoveSubscriberAction } from "./remove-subscriber-action"

export type SubscriberColumns = {
  userId: string
  lettermemeId: string
  createdAt: string
  user: {
    id: string
    email: string
  }
}

export const columns: ColumnDef<SubscriberColumns | null | undefined>[] = [
  {
    accessorKey: "user.email",
    header: "Email",
    cell: ({ row }) => {
      return <div className="text-sm">{row.original?.user.email}</div>
    },
  },
  {
    accessorKey: "createdAt",
    header: "Subscribed",
    cell: ({ row }) => {
      const createdAt = row.getValue("createdAt") as string
      return <div className="text-sm">{formatRelativeTime(parseISO(createdAt))}</div>
    },
  },
  {
    accessorKey: "unsubscribedAt",
    header: "Unsubscribed",
    cell: ({ row }) => {
      const unsubscribedAt = row.getValue("unsubscribedAt") as string | null | undefined
      return (
        <div className="text-sm">
          {unsubscribedAt ? formatRelativeTime(parseISO(unsubscribedAt)) : "-"}
        </div>
      )
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      const subscriber = row.original
      if (!subscriber) return null
      return (
        <RemoveSubscriberAction
          userId={subscriber.userId}
          userEmail={subscriber.user.email}
          lettermemeId={subscriber.lettermemeId}
        />
      )
    },
  },
]
